// extracted by mini-css-extract-plugin
var _1 = "nteC6";
var _2 = "GghNC";
export { _1 as "base", _2 as "loadingMessage" }
